"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _chunkOX4QNVYYjs = require('./chunk-OX4QNVYY.js');

var _jsxruntime = require('react/jsx-runtime');

var o = _chunkOX4QNVYYjs.c.call(void 0, {
  name: "SearchIconSmall",
  size: "Small",
  svg: _jsxruntime.jsx.call(void 0, "path", {
    clipRule: "evenodd",
    d: "M8.7051 3.00327L8.54333 3.00006C7.06981 2.99339 5.65483 3.57633 4.61361 4.61902C3.57239 5.66171 2.99141 7.07753 3.0001 8.55107C3.01339 11.6264 5.50116 14.1179 8.57695 14.1356C9.58378 14.14 10.5685 13.8678 11.4258 13.3537L11.6076 13.2399L15.0214 16.6494C15.3035 16.9455 15.7333 17.068 16.138 16.9629C16.5426 16.8578 16.8585 16.5417 16.9632 16.1369C17.068 15.7322 16.9451 15.3025 16.6423 15.0143L13.2344 11.6048C13.8158 10.7076 14.1249 9.65838 14.1202 8.58469C14.1071 5.56305 11.7058 3.10542 8.7051 3.00327ZM8.36699 4.78012L8.54327 4.7767L8.68245 4.78C10.7146 4.8646 12.3361 6.53391 12.3451 8.58419C12.3508 9.58631 11.9558 10.5487 11.248 11.2575C10.5403 11.9663 9.57857 12.3628 8.57694 12.3586C6.48066 12.3465 4.78458 10.6481 4.77537 8.55111C4.76972 7.54898 5.16473 6.58663 5.87248 5.87781C6.53852 5.21076 7.4295 4.82034 8.36699 4.78012Z",
    fillRule: "evenodd"
  }),
  svgElements: ["path"]
}),
    n = exports.b = _chunkOX4QNVYYjs.c.call(void 0, {
  name: "SearchIconMedium",
  size: "Medium",
  svg: _jsxruntime.jsx.call(void 0, "path", {
    clipRule: "evenodd",
    d: "M13.1501 5.00467L12.919 5.00008C10.814 4.99056 8.79262 5.82333 7.30515 7.31289C5.81769 8.80244 4.98772 10.825 5.00014 12.9301C5.01912 17.3234 8.57309 20.8827 12.9671 20.908C14.4054 20.9143 15.8121 20.5255 17.0369 19.791L17.2965 19.6284L22.1735 24.4991C22.5765 24.9222 23.1905 25.0971 23.7685 24.947C24.3466 24.7969 24.7979 24.3452 24.9475 23.767C25.0971 23.1888 24.9216 22.575 24.489 22.1633L19.6206 17.2926C20.4512 16.0109 20.8927 14.512 20.886 12.9781C20.8673 8.66149 17.4369 5.15059 13.1501 5.00467ZM12.6671 7.54278L12.9189 7.53789L13.1178 7.54261C16.0208 7.66347 18.3373 10.0482 18.3502 12.9772C18.3582 14.4088 17.7939 15.7836 16.7829 16.7962C15.7718 17.8087 14.3979 18.3751 12.967 18.3692C9.97234 18.3519 7.54937 15.9256 7.53622 12.9299C7.52814 11.4983 8.09245 10.1235 9.10351 9.11091C10.055 8.15797 11.3278 7.60024 12.6671 7.54278Z",
    fillRule: "evenodd"
  }),
  svgElements: ["path"]
});

exports.a = o;
exports.b = n;